import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { Alert, Container } from "react-bootstrap";
import api from "utils/axiosInstance";
import formatMinutes from "utils/formatMinutes";

const columns = [
  { field: "userId", headerName: "UserID", flex: 1 },
  { field: "randomization", headerName: "Study Group", flex: 1 },
  { field: "datesIncluded", headerName: "Login Dates", flex: 1 },
  { field: "weekNumber", headerName: "Week Number", flex: 1 },
  { field: "timeSpent", headerName: "Total Time Spent", flex: 1 },
];

export function UserTrackingDetails({ userId }) {
  const [timeSpentData, setTimeSpentData] = useState([]);
  const [error, setError] = useState({ state: false, message: "" });

  useEffect(() => {
    (async function () {
      const timeSpentDataResponse = await getTimespentData();
      if (timeSpentDataResponse !== null)
        setTimeSpentData(
          timeSpentDataResponse.map((data, idx) => ({
            id: idx,
            timeSpent: formatMinutes(data.timeSpentMinutes),
            ...data,
          }))
        );
    })();
  }, [userId]);

  async function getTimespentData() {
    try {
      const timeSpentRes = await api({
        method: "get",
        url: `/User/tracking/${userId}`,
      });
      return timeSpentRes.data;
    } catch (err) {
      setError({
        state: true,
        message:
          (err.response && err.response.data.message) ||
          "An Unknown error occured",
      });
    }
  }

  return (
    <Container>
      {error.state && <Alert variant="danger">{error.message}</Alert>}
      <Box sx={{ height: "100vh", width: "100%" }}>
        {timeSpentData && timeSpentData.length > 0 ? (
          <h1>Yet to come</h1>
        ) : (
          <div>No data found</div>
        )}
      </Box>
    </Container>
  );
}
